var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScale = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 65,
  height: 65,
  viewBox: "0 0 65 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.9093 59.1818H64.0002V1H5.81836V40.0909",
  stroke: "#BDCAD1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.0909 35.9092H0V65.0001H29.0909V35.9092Z",
  fill: "#845EC2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M47.1854 35.9091V17.8146H29.0908",
  stroke: "#BDCAD1",
  strokeWidth: 2,
  strokeMiterlimit: 10
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.0908 35.9091L47.1854 17.8146",
  stroke: "#BDCAD1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgScale);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scale.0570b7041ac19be72baa78aad8615dc3.svg";